"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateNursysTransactionDto = instanceOfCreateNursysTransactionDto;
exports.CreateNursysTransactionDtoFromJSON = CreateNursysTransactionDtoFromJSON;
exports.CreateNursysTransactionDtoFromJSONTyped = CreateNursysTransactionDtoFromJSONTyped;
exports.CreateNursysTransactionDtoToJSON = CreateNursysTransactionDtoToJSON;
exports.CreateNursysTransactionDtoToJSONTyped = CreateNursysTransactionDtoToJSONTyped;
const NursysTransactionType_1 = require("./NursysTransactionType");
/**
 * Check if a given object implements the CreateNursysTransactionDto interface.
 */
function instanceOfCreateNursysTransactionDto(value) {
    if (!('transactionId' in value) || value['transactionId'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function CreateNursysTransactionDtoFromJSON(json) {
    return CreateNursysTransactionDtoFromJSONTyped(json, false);
}
function CreateNursysTransactionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'transactionId': json['transactionId'],
        'type': (0, NursysTransactionType_1.NursysTransactionTypeFromJSON)(json['type']),
        'licenseIds': json['licenseIds'] == null ? undefined : json['licenseIds'],
        'ncsbnIds': json['ncsbnIds'] == null ? undefined : json['ncsbnIds'],
    };
}
function CreateNursysTransactionDtoToJSON(json) {
    return CreateNursysTransactionDtoToJSONTyped(json, false);
}
function CreateNursysTransactionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'transactionId': value['transactionId'],
        'type': (0, NursysTransactionType_1.NursysTransactionTypeToJSON)(value['type']),
        'licenseIds': value['licenseIds'],
        'ncsbnIds': value['ncsbnIds'],
    };
}
//# sourceMappingURL=CreateNursysTransactionDto.js.map